import React from 'react';
import { BASE_IMAGE_URL } from '../../config/apiConfig';

interface ImageComponentProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  alt: string;
  className?: string;
  priority?: boolean;
  width?: number;
  height?: number;
}

const ImageComponent: React.FC<ImageComponentProps> = ({ 
  src, 
  alt, 
  className,
  priority = false,
  width,
  height,
  ...props 
}) => {
  const imageUrl = (src?.startsWith('https://'))
    ? src
    : !src ? '/assets/image-movie.png' : `${BASE_IMAGE_URL}${src}`;
    
  const isPlaceholder = imageUrl === '/assets/image-movie.png';

  // Add size parameters to the URL if it's from BASE_IMAGE_URL
  const sizedImageUrl = !isPlaceholder && imageUrl.includes(BASE_IMAGE_URL) && width
    ? `${imageUrl}?w=${width}${height ? `&h=${height}` : ''}`
    : imageUrl;

  return (
    <img
      {...props}
      src={sizedImageUrl}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      className={
        (className || '') + (isPlaceholder ? ' object-contain' : '')
      }
      style={isPlaceholder ? { width: '100%', height: 'auto', objectFit: 'contain' } : undefined}
    />
  );
};

export default ImageComponent;
